export default "__VITE_ASSET__Dg9AgDkS__"